module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=AE - United Arab Emirates.52c80363.svg";